const createReadOptionsCallback = ({ route, entityId, getSearchFilters, extraBody }) => ({
  httpMethod: 'POST',
  route,
  generateBody: (searchTerm) => ({
    ...(extraBody?.() ?? {}),
    filters: entityId
      ? [{ operation: 'equalsID', field: '_id', value: entityId }]
      : getSearchFilters(searchTerm),
  }),
});

const corporationsAPICallback = (corpId) =>
  createReadOptionsCallback({
    route: 'corporations/read',
    entityId: corpId,
    getSearchFilters: (searchTerm) => [
      { operation: 'icontains', field: 'name', value: searchTerm },
    ],
  });

const employeeAPICallback = (employeeId) =>
  createReadOptionsCallback({
    route: 'users/read',
    entityId: employeeId,
    getSearchFilters: (searchTerm) =>
      [
        { operation: 'icontains', field: 'name', value: searchTerm },
        { operation: 'equals', field: 'role', value: 'candidate' },
      ].filter((i) => i),
  });

const departmentAPICallback = (corpId, departmentId) =>
  createReadOptionsCallback({
    route: 'corporations/departments/read',
    entityId: departmentId,
    getSearchFilters: (searchTerm) =>
      [searchTerm && { operation: 'icontains', field: 'name', value: searchTerm }].filter((i) => i),
    extraBody: () => ({ ...(corpId && { corporation: corpId }) }),
  });

const locationsAPICallback = (corpId, locationId) =>
  createReadOptionsCallback({
    route: 'locations/read',
    entityId: locationId,
    getSearchFilters: (searchTerm) =>
      [
        searchTerm && { operation: 'icontains', field: 'address', value: searchTerm },
        corpId && { operation: 'equalsID', field: 'corporation._id', value: corpId },
      ].filter((i) => i),
  });

const agencyAPICallback = (agencyId) =>
  createReadOptionsCallback({
    route: 'agency/read',
    entityId: agencyId,
    getSearchFilters: (searchTerm) => [
      { operation: 'icontains', field: 'name', value: searchTerm },
    ],
  });

export {
  agencyAPICallback,
  corporationsAPICallback,
  departmentAPICallback,
  employeeAPICallback,
  locationsAPICallback,
};
